import Vue from 'vue';
// import moment from 'moment';
import moment from 'moment-timezone';

// Truncate very long titles
const truncate = Vue.filter('truncate', function(value, limit) {
  if (value.length >= limit) {
    return (value = value.substring(0, limit - 3) + '...');
  }

  return value;
});

const formatDate = Vue.filter('formatDate', function(date, options) {
  if (!date || typeof date !== 'string') {
    return ' ';
  }

  options = options || {};
  const hasHourAndMinutes = options.hasHourAndMinutes;

  if (!hasHourAndMinutes && date.indexOf(' ') !== -1) {
    return date.split(' ')[0];
  }

  return date;
});

const formatDateComputed = Vue.filter('formatDateComputed', function(date, options) {
  const { format, timezone, hasHourAndMinutes } = options;
  moment.tz.setDefault('Europe/London');
  moment.tz.setDefault('Europe/London');
  if (!date) return;
  if (!timezone) return;
  const [tzName] = timezone.split(' ');
  return moment(date)
    .tz(tzName)
    .format(`${format} ${hasHourAndMinutes ? 'HH:mm' : ''}`);
});

// Remove http/https and domain extension from url's
const prettifyUrl = Vue.filter('prettifyUrl', function(url) {
  if (url) {
    return url.replace(/^https?:\/\/|www\./gi, '');
  }

  return 'N/A';
});

export default {
  truncate,
  formatDate,
  formatDateComputed,
  prettifyUrl,
};
